"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = { class: "local-main-page" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ListView = (0, vue_1.resolveComponent)("ListView");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_ListView, {
            ref: "list-view",
            "complex-list": _ctx.mainData,
            option: _ctx.listOption
        }, null, 8, ["complex-list", "option"])
    ]));
}
exports.render = render;
